import { useAuth0 } from '@auth0/auth0-react'
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'

/**
 * Hook to sync Auth0 user state with Sentry for error tracking
 * Only tracks anonymous user ID - no PII/PHI is sent to Sentry
 */
export function useSentryUser() {
  const { isAuthenticated, user } = useAuth0()

  useEffect(() => {
    if (isAuthenticated && user) {
      // Set Sentry user context with only the user ID (no PII/PHI)
      Sentry.setUser({
        id: user.sub, // Auth0 user ID (e.g., "auth0|123456")
        // Explicitly DO NOT include:
        // - email
        // - name
        // - phone
        // - or any other PII/PHI
      })
    } else {
      // Clear user context on logout
      Sentry.setUser(null)
    }
  }, [isAuthenticated, user])
}
